/** @format */

import React from 'react';
import Header from 'components/Layout/Header';
import Footer from 'components/Layout/Footer';
import LeadServiceLayout from 'components/LeadsServiceContentV2';
import Container from 'react-bootstrap/Container';
import { LeadsSectionBody, LeadSources } from 'components/LeadsGenerator';

import './styles.scss';

export default function LeadsServiceArticlePage(props) {
  const text = props.t('lang_registration:monitor_article');
  const { isMobileView } = props;

  return (
    <>
      <div className='main-container leads-service-article-page-container'>
        <Header {...props} />
        <div className='inner-container'>
          <Container>
            {/* Page content here */}
            <LeadServiceLayout
              text={text}
              isMobileView={isMobileView}
              mainImage='images/leads-service-hero.png'>
              <LeadsSectionBody
                metadata={{
                  source: LeadSources.FM_LEAD_SERVICE_V2
                }}
                showPropertyTypes={true}
                showUrgency={true}
                showTextInputs={true}
                showLeadTypes={true}
                showSquareMeterInput={true}
                showNumberOfRoomsInput={true}
                showAddressInput={true}
                showBrokerStatusSelector={false}
                showTelephoneInput={true}
                isMinForm={true}
                {...props}
              />
            </LeadServiceLayout>
          </Container>
        </div>

        <Footer {...props} />
      </div>
    </>
  );
}
